import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [

  {
    path: '/:code/:type',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '../views/index.vue'),
    meta:{
      cardShow: true
    },
  },
  {
    path: '/materialLibrary',
    name: 'materialLibrary',
    component: () => import(/* webpackChunkName: "about" */ '../views/materialLibrary.vue'),
    meta:{
      cardShow: false
    },
  },
  {
    path: '/video',
    name: 'video',
    component: () => import(/* webpackChunkName: "about" */ '../views/video.vue'),
    meta:{
      cardShow: false,
    },
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  // console.log(to,'路由守卫to')
  // console.log(from,'路由守卫from')
  if (from.path === '/' && to.params.code && to.params.type){
    next()
  }
  else if (from.path === '/' && to.path === '/materialLibrary'){
    next()
  }
  else if (from.path === '/' && to.path === '/video' && to.query.id){
    next()
  }
  else if (from.path === '/' && !(to.params.code && to.params.type)){
    next(
        {path: '/0/0'}
    )
  }
  if (to.params.code &&  to.params.type){
    next()
  }
  else {
    next()
  }
})
export default router
